// extracted by mini-css-extract-plugin
export default {"button":"jp-z","reviewSort":"kp-z"};